<mat-accordion class="plain-expansion-accordion">

  <!-- reset - not always shown -->
  <mat-expansion-panel class="categories level_one" [class.not-sidebar]="!getIsSideBar" [disabled]="true" *ngIf="withReset">
    <mat-expansion-panel-header fxLayout="row">
      <div class="category-expander unselectable" (click)="$event.stopPropagation();reset()">
        <div class="category-icon" [ngStyle]="{'color':'black'}">
          <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x"></i>
          </span>
        </div>
        <div class="category-name unselectable">
          Alle
        </div>
      </div>
    </mat-expansion-panel-header>
  </mat-expansion-panel>

  <!-- level 1 cat -->

  <div class="categories-section-container" [class.not-sidebar]="!getIsSideBar">
    <ng-container *ngFor="let category of categories; let a = index">
      <ng-container *ngIf="category.type === 'video' && categories[a-1]?.type !== 'video'">
        <span class="categories-type-heading">Beitrag mit Video erstellen</span>
      </ng-container>

      <ng-container *ngIf="category.type === 'image' && categories[a-1]?.type !== 'image'">
        <span class="categories-type-heading">Beitrag mit Fotos erstellen</span>
      </ng-container>


      <div class="categories-container">
        <mat-expansion-panel class="categories level_one"
          [disabled]="!category.children || category.children.length == 0 " [expanded]="category.childmatched"
          (opened)="scrollTo('.acecat1'+a); category.childmatched=true" (closed)="category.childmatched=false"
          [class.selected]="categoriesEqual(value,category)">


          <div [class]="'acecat1'+a"></div>

          <mat-expansion-panel-header class="category-name">
            <div class="category-expander"
              (click)="$event.stopPropagation();onlySecondLevelSelectable ? category.childmatched=true : selectCategory(category)">
              <div class="category-icon" [ngStyle]="{'color':category.color}">
                <span class="fa-stack">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas {{category.icon}} fa-stack-1x fa-inverse"></i>
                </span>
              </div>
              <div class="category-name unselectable">
                {{category.name}}
              </div>
            </div>
          </mat-expansion-panel-header>

          <!-- level 2 cats -->
          <ng-container *ngIf="category.children && category.children.length > 0 ">
            <mat-accordion class="plain-expansion-accordion">
              <ng-container *ngFor="let child of category.children; let b = index">

                <mat-expansion-panel class="category-children"
                  [disabled]="!child.children || child.children.length == 0" [expanded]="child.childmatched"
                  (opened)="scrollTo('.acecat2'+b)" [class.selected]="categoriesEqual(value,child)">

                  <div [class]="'acecat2'+b"></div>

                  <mat-expansion-panel-header>
                    <div class="category-expander" (click)="$event.stopPropagation();selectCategory(child)">
                      <div [className]="categoriesEqual(value,child) ? 'selected category-name' : 'category-name'">
                        <div class="category-icon" [ngStyle]="{'color':child.color}">
                          <span class="fa-stack">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas {{child.icon}} fa-stack-1x fa-inverse"></i>
                          </span>
                        </div>
                        <div style="padding: 0px 10px;" class="category-child unselectable">
                          {{child.name}}
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel-header>

                  <div *ngIf="child.children && child.children.length > 0">
                    <div class="category-children second">
                      <ng-container *ngFor="let subChild of child.children">
                        <div [className]="categoriesEqual(value,subChild) ? 'selected category-name' : 'category-name'"
                          (click)="selectCategory(subChild)">

                          <div class="category-icon" [ngStyle]="{'color':subChild.color}">
                            <span class="fa-stack">
                              <i class="fas fa-circle fa-stack-2x"></i>
                              <i class="fas {{subChild.icon}} fa-stack-1x fa-inverse"></i>
                            </span>
                          </div>

                          <div style="padding: 0px 10px;" class="category-child unselectable">
                            {{subChild.name}}
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </ng-container>


        </mat-expansion-panel>

      </div>
    </ng-container>
  </div>

</mat-accordion>